export default "__VITE_ASSET__8BRSToQu__"